export default __webpack_public_path__ + "static/media/TF.dca88f90.png";